import { useMediaQuery } from 'react-responsive';
import Home from './Home';
import MobileHome from './MobileHome';

const HomeRouter = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 }); // adjust breakpoint if needed

  return isMobile ? <MobileHome /> : <Home />;
};

export default HomeRouter;
